import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'

import {
  setActiveTab,
  updateSavedSearchFilters,
  setSearchText,
  setBlockerFilters,
} from '../../store/userSearchProfile'

export const useSearchPage = () => {
  const dispatch = useDispatch()
  const [isCollapsed, setIsCollapsed] = useState(false)

  const handleParentStore = useCallback(
    (parentStore) => {
      const dashboardData = parentStore.getState().searchHeader
      const { activeTab, searchText, blockerFilter } = dashboardData
      dispatch(updateSavedSearchFilters('all'))
      dispatch(setSearchText(searchText))
      dispatch(setBlockerFilters(blockerFilter))
      const tabName = activeTab || 'data_ready_status'
      dispatch(setActiveTab(tabName)) // dispatch to local store
    },
    [dispatch],
  )

  return {
    setIsCollapsed,
    isCollapsed,
    handleParentStore,
  }
}
